module.exports = __webpack_public_path__ + "img/P150T_weapon_139.9863dfa1.png";